import React from 'react';

import Button, { LinkButton } from '@atlaskit/button/new';
import Spinner from '@atlaskit/spinner';

export const PrimaryAndSecondaryCTAActionsGroup = ({
	secondaryCTALabel,
	onSecondaryCTAClick,
	primaryCTALabel,
	onPrimaryCTAClick,
	href,
	isLoading,
}: {
	href?: string;
	isLoading?: boolean;
	onPrimaryCTAClick: (e?: React.MouseEvent<HTMLAnchorElement>) => void;
	onSecondaryCTAClick: () => void;
	primaryCTALabel: string;
	secondaryCTALabel: string;
}) => {
	return (
		<>
			<Button appearance="subtle" onClick={onSecondaryCTAClick}>
				{secondaryCTALabel}
			</Button>
			<LinkButton
				href={href ?? ''}
				appearance="primary"
				target="_blank"
				isDisabled={isLoading}
				onClick={onPrimaryCTAClick}
				color="brand"
			>
				{isLoading ? <Spinner size="small" label="Loading" /> : <>{primaryCTALabel}</>}
			</LinkButton>
		</>
	);
};
